import { useEffect, useState } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import Login from "./pages/Login.jsx";
import Tenders from "./pages/Tenders.jsx";
import TenderDetail from "./pages/TenderDetail.jsx";
import Layout from "./components/Layout.jsx";
import { api, clearToken, getToken } from "./api.js";

export default function App() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!getToken()) {
      setChecking(false);
      return;
    }
    api
      .me()
      .then(setUser)
      .catch(() => {
        clearToken();
        setUser(null);
      })
      .finally(() => setChecking(false));
  }, []);

  const handleLogin = (u) => setUser(u);
  const handleLogout = () => {
    clearToken();
    setUser(null);
    navigate("/login");
  };

  if (checking) {
    return (
      <div className="flex min-h-screen items-center justify-center text-ink-500">
        Wird geladen …
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={
          user ? <Navigate to="/" replace /> : <Login onLogin={handleLogin} />
        }
      />
      <Route
        path="/"
        element={
          user ? (
            <Layout user={user} onLogout={handleLogout}>
              <Tenders />
            </Layout>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/tenders/:id"
        element={
          user ? (
            <Layout user={user} onLogout={handleLogout}>
              <TenderDetail />
            </Layout>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
